import getCacheKey from "@/vue/planning/logic/getCacheKey"
import responsesCache from "@/vue/planning/state/responsesCache"
import { getQuoteRequestData } from "@/vue/planning/logic/getRequestData"
import { PricesResponse } from "@/types/responses"
import * as _ from "lodash"
import { getUniqueId } from "@/vue/planning/logic/uniqueId"
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet"

const getPrice = async (
	packCode: string,
	startDate: string,
	endDate: string,
	storeObj: any
): Promise<PricesResponse> => {
	if (packCode === "HS") throw new Error("cannot request prices for HS package")

	// try to extract cached response
	const cacheKey = getCacheKey(
		packCode,
		startDate,
		endDate,
		storeObj.state.season,
		storeObj.state.participants
	)
	const existingPrices = responsesCache.value.getResponse("prices", cacheKey)
	if (existingPrices) return existingPrices

	// if no cached response - make a request
	const pricePromise: Promise<PricesResponse> = new Promise(async (resolve) => {
		pricesLoadingSet.value.add(cacheKey)
		pricesLoadingSet.value = _.cloneDeep(pricesLoadingSet.value)

		const requestData = getQuoteRequestData(
			storeObj.state,
			storeObj.getters,
			packCode
		)
		const price_resp = await window.bookingService.getQuotePrices(requestData)

		storeObj.state.packageId = price_resp?.availablePackages?.find(
			(packObj: any) => {
				return packObj.codePackage === packCode
			}
		)?.prestId

		price_resp.prestations = price_resp.prestations.map((prest: any) => {
			prest["id"] = getUniqueId(prest)
			// do not recompute pricePerPerson as in availabilities because IRESA already did the computation in response
			return prest
		})

		const newMapObj = { ...storeObj.state.prestMaps.quotePrices }
		newMapObj[packCode] = {}
		if (!price_resp) return
		if (Object.keys(price_resp).length !== 0) {
			price_resp["prestations"].forEach(
				(prest: any) => (newMapObj[packCode][prest.id] = prest)
			)
		}
		storeObj.state.prestMaps.quotePrices = newMapObj

		responsesCache.value.setResponse("prices", cacheKey, price_resp)
		responsesCache.value = _.cloneDeep(responsesCache.value)

		pricesLoadingSet.value.delete(cacheKey)
		pricesLoadingSet.value = _.cloneDeep(pricesLoadingSet.value)

		// Set calledPrice to true for tracking
		storeObj.state.calledPrice = true
		resolve(price_resp)
	})
	return pricePromise
}

export default getPrice
